/**
 * Шкала шрифта экранов справочника техники — шесть размеров на всё. В теме
 * (`shared/theme/tokens.ts`) типографической шкалы пока нет, поэтому она
 * собрана здесь, в одном месте; кандидат в общие токены.
 */
export const fleetType = {
  /** Подписи колонок и эйбрау. */
  micro: '11px',
  /** Метки, подсказки, мелкие значения. */
  small: '12px',
  /** Ячейки таблиц, подписи полей. */
  body: '13px',
  /** Основной текст и значения паспорта. */
  base: '14px',
  /** Заголовки блоков. */
  lead: '16px',
  /** Заголовок карточки, крупная цифра. */
  title: '20px',
} as const;

/** Межстрочные интервалы под эту шкалу. */
export const fleetLeading = {
  tight: 1.25,
  normal: 1.45,
} as const;
